var render = function render(){var _vm=this,_c=_vm._self._c;return _c('audio',{attrs:{"controls":"","src":_vm.src,"preload":"none"},on:{"play":_vm.onPlay,"pause":_vm.onPause,"ended":_vm.onEnded,"error":_vm.onError}})
}
var staticRenderFns = []

export { render, staticRenderFns }